import { Exclude, Expose, Type } from 'class-transformer';
import { BaseModel } from './base.model';
import { Default } from '@core/util';

@Exclude()
export class CrsTaxResidenceMetadataModel extends BaseModel {
  @Expose() order!: number;
}

@Exclude()
export class CrsTaxResidenceModel extends BaseModel {
  @Expose() @Default(null) id!: number | null;

  @Expose() countryId!: number;

  @Expose() @Default(true) isHaveTIN!: boolean;

  @Expose() tin!: string;

  @Expose() @Type(() => CrsTaxResidenceMetadataModel) metadata!: CrsTaxResidenceMetadataModel;
}
